var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_4541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 9.296V19.04L29.392 16.8C28.144 15.728 26.128 15.728 24.88 16.8L18.224 22.512C16.976 23.584 14.96 23.584 13.712 22.512L13.168 22.064C12.032 21.072 10.224 20.976 8.944 21.84L1.072 27.12L0.896 27.248C0.304 25.968 0 24.448 0 22.704V9.296C0 3.472 3.472 0 9.296 0H22.704C28.528 0 32 3.472 32 9.296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2017 13.409C12.2117 13.409 13.1803 13.0078 13.8944 12.2936C14.6085 11.5795 15.0097 10.6109 15.0097 9.60097C15.0097 8.59102 14.6085 7.62244 13.8944 6.90831C13.1803 6.19417 12.2117 5.79297 11.2017 5.79297C10.1918 5.79297 9.2232 6.19417 8.50907 6.90831C7.79493 7.62244 7.39373 8.59102 7.39373 9.60097C7.39373 10.6109 7.79493 11.5795 8.50907 12.2936C9.2232 13.0078 10.1918 13.409 11.2017 13.409ZM31.9985 19.0378V22.7018C31.9985 28.5258 28.5265 31.9978 22.7025 31.9978H9.29453C5.21453 31.9978 2.27053 30.2858 0.894531 27.2458L1.07053 27.1178L8.94253 21.8378C10.2225 20.9738 12.0305 21.0698 13.1665 22.0618L13.7105 22.5098C14.9585 23.5818 16.9745 23.5818 18.2225 22.5098L24.8785 16.7978C26.1265 15.7258 28.1425 15.7258 29.3905 16.7978L31.9985 19.0378Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_4541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.f9a15e1c1b6b86656db2935bf062527b.svg";
export { ForwardRef as ReactComponent };